export default "__VITE_ASSET__7140c790__"